import { cn } from "../lib/utils";

export interface TabItem {
  key: string;
  label: string;
  disabled?: boolean;
}

export interface TabsProps {
  tabs: TabItem[];
  current: string;
  onChange: (key: string) => void;
  className?: string;
}

export function Tabs({ tabs, current, onChange, className }: TabsProps) {
  return (
    <div className={cn("flex border-b border-border", className)}>
      {tabs.map((t) => {
        const active = t.key === current;
        return (
          <button
            key={t.key}
            type="button"
            disabled={t.disabled}
            onClick={() => onChange(t.key)}
            className={cn(
              "py-2.5 px-4 text-xs font-medium transition-colors border-b-2 -mb-px",
              active
                ? "border-primary text-ink"
                : "border-transparent text-ink-subtle hover:text-ink-muted",
              t.disabled && "opacity-40 cursor-not-allowed hover:text-ink-subtle",
            )}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
